import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=6233090c"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports